import Header from "./Header";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import SwiperCore from 'swiper';
import { Autoplay } from 'swiper/modules';
import slider1 from '../img/background/1.png';
import slider2 from '../img/background/2.png';
import slider3 from '../img/background/6.png';
import featuredimg from '../img/background/featured.jpeg';
import titleicon from '../img/title-icon.png';
import project1 from '../img/background/project1.png';
import service4  from '../img/background/pipe.png';
import service2  from '../img/background/design.png';
// import service3  from '../img/background/ductwork.jpg';
import service3  from '../img/background/duct.png';
import service5  from '../img/background/projectmanagement.jpg';
import service7  from '../img/background/construction.jpg';
import service6  from '../img/background/const.png';

import mixitup from 'mixitup';
import { useEffect, useState } from 'react';
import Footer from "./Footer";


SwiperCore.use([Autoplay]);

export default function Home() {

  useEffect(() => {
  const containerEl = document.querySelector('#mixitup-projects');

  if (containerEl) {
    mixitup(containerEl, {
      selectors: {
        target: '.mix'
      },
      animation: {
        duration: 300
      }
    });
  }
}, []);



  const [selectedFilter, setSelectedFilter] = useState('All');

  const filters = [
    'All',
    'Educational',
    'Apartments',
    'Aged Care',
    'Restaurants',
    'Place Of Worship',
    'Design & Construct',
    'Other'
  ];

  const projects_1 = [
  {
    img: project1,
    title: 'Educational',
    text: 'Full HVAC installation with multi-split systems, VRV, and filtered outside air solutions.',
    categories: ['Educational']
  },
  {
    img: project1,
    title: 'Place Of Worship',
    text: 'Custom HVAC system with Actron package units, ventilation, and filtered outside air.',
    categories: ['Place Of Worship']
  },
  {
    img: project1,
    title: 'Aged Care',
    text: 'Specialist HVAC solutions tailored for aged care with heat recovery VRV and full system compliance.',
    categories: ['Aged Care']
  },
  {
    img: project1,
    title: 'Others',
    text: 'Industrial HVAC delivery with advanced cooling and ventilation systems for high-demand sites.',
    categories: ['Other']
  },
  {
    img: project1,
    title: 'Design & Construct',
    text: 'Complete design & construct project delivering tailored HVAC solutions for automotive retail spaces.',
    categories: ['Design & Construct']
  },
  {
    img: project1,
    title: 'Apartments',
    text: 'Multi-split VRV systems with carpark extract and outside air integration for modern living spaces.',
    categories: ['Apartments']
  }
];



const projects = [
  {
    title: 'Educational',
    items: [
      'Alkimos North East Primary School',
      'Banksia Grove West Primary School',
      'Byford Secondary College',
      'Springfield Primary School',
      'Wellard Primary School',
      'Eglinton Primary School',
      'Brabham East Primary School',
      'Mount Lawley Senior High School',
      'Wattleup East Primary School',
      'Madora Bay Primary School',
      'Kyilla Primary School',
      'Landsdale Primary School',
      'Arbor Grove Primary School – Refurbishment',
      'Southern River Primary School',
      'Brabham Primary School',
      'Banksia Grove East Primary School',
      'Byford South East Primary School',
      'Baldivis North Primary School',
      'North Morley Primary School',
      'Pine View Primary Education Support Centre Hub',
      'Kinross Primary School',
      'Mount Claremont Primary School – Admin Upgrade',
      'Seaforth Primary School – Admin Upgrade'
    ]
  },
  {
    title: 'Apartments',
    items: [
      'Saunton Apartments, Jindalee',
      'Bunbury Apartments'
    ]
  },
  {
    title: 'Aged Care',
    items: [
      'Narrogin Cottage Homes',
      'MercyCare Aged Care, Edgewater'
    ]
  },
  {
    title: 'Restaurants',
    items: [
      'Pretty Pool Café, Port Hedland',
      'Monelli Italian Fine Dining, Burns Beach',
      'Ocean 205, Bunbury'
    ]
  },
  {
    title: 'Place Of Worship',
    items: [
      'Kingdom of Light Church, Cockburn Central',
      "St. Peter's Jacobite Church, Wattle Grove",
      'Carmel Bible Church, Willetton',
      'Perth Pentecostal Assembly, Bibra Lake'
    ]
  },
  {
    title: 'Other',
    items: [
      'Yara Tan Burrup Ammonium Nitrate Facility, Karratha',
      'BHP Macedon Permanent Buildings, Onslow',
      'Newman Arts Centre, Newman',
      'Newman Airport Expansion, Newman',
      'Main Roads, Narrogin',
      'Main Roads, Northam',
      'Netball Pavilion, South Hedland',
      'Paraburdoo Child Care Centre',
      'Coventry Office Expansion, Redcliffe',
      'Freedom Furniture Showroom, Osborne Park',
      'Officeworks, Osborne Park',
      'Transportable School Buildings',
      'Yanchep Active Open Space, Yanchep',
      'Pingelly Recreation Centre, Pingelly',
      'Greyhounds Pavilion, Cannington',
      'Seville Grove Library & Champion Centre',
      'Northline Distribution Centre, Kenwick',
      'Goodlife Gym, Joondalup',
      'EPIC Community Centre, Karratha',
      'Cannington/Welshpool SER/TSER Buildings (Armadale Line Upgrade)',
      "Ingham's Chicken Facility, Osborne Park",
      'Hazelmere Resource Recovery Park',
      'Kelmscott Hall Upgrade',
      'Surfing WA Headquarters, Trigg',
      'Wellington Post Office, Perth'
    ]
  },
  {
    title: 'Design & Construct',
    items: [
      'Yara Tan Burrup Ammonium Nitrate Facility, Karratha',
      'Monelli Italian Fine Dining, Burns Beach',
      'Ocean 205, Bunbury',
      'Paraburdoo Child Care Centre',
      'Coventry Office Expansion, Redcliffe',
      'Freedom Furniture Showroom, Osborne Park',
      'Officeworks, Osborne Park',
      'Toyota & Holden Showroom, Broome',
      'Jeep Showroom, Rockingham',
      'Greyhounds Pavilion, Cannington',
      "St. Peter's Jacobite Church, Wattle Grove",
      'Carmel Bible Church, Willetton',
      'Perth Pentecostal Assembly, Bibra Lake'
    ]
  }
];


  // const filteredProjects =
  //   selectedFilter === 'All'
  //     ? projects
  //     : projects.filter((project) =>
  //         project.categories.includes(selectedFilter)
  //       );

  const filteredProjects =
  selectedFilter === 'All'
    ? projects
    : projects.filter((project) => project.title === selectedFilter);



        const services = [service2,service2, service3,service4,service5,service6,service7];

  return (

    <div>
      <Header />


      <div className="slider-area">
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          <SwiperSlide>
            <div className="single-slider bg-with-black">
              <div className="img">
                <img src={slider1} alt="slider img 1" />
              </div>
              <div className="content">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="slider-overlay-container">
                        <div className="slider-overlay"></div>
                        <div className="slider-content">
                          <h3 className="intro animated">
                            <span className="activeColor1">TRACS</span> 
                          </h3>
                          <h2 className="title animated">Built for Western Australia</h2>
                          <p className="text animated">
                           With over 25 years of local experience, our team understands the demands of WA’s climate,
  <br />
  industries, and construction standards—ensuring fit-for-purpose solutions every time.
                          </p>
                        </div>
                      </div>

                      <div className="buttons animated">
                        <a className="link btn btn-primary" href="services">
                          Our Services
                        </a>
                        <a className="link btn btn-primary activeBorder" href="contact">
                          Contact Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Repeat for Slide 2 */}
          <SwiperSlide>
            <div className="single-slider bg-with-black">
              <div className="img">
                <img src={slider2} alt="slider img 2" />
              </div>
              <div className="content text-center">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-12">
                    <div className="slider-overlay-container">
  <div className="slider-overlay"></div>
  <div className="slider-content">
    <h3 className="intro animated">
      <span className="activeColor1">TRACS</span> 
    </h3>
    <h2 className="title animated">Innovative HVAC Solutions</h2>
    <p className="text animated">
      From concept to commissioning, we deliver customised air conditioning and mechanical systems
  <br />
  built for performance, efficiency, and long-term reliability across all sectors.
    </p>
  </div>
</div>

                      <div className="buttons animated">
                        <a className="link btn btn-primary" href="services">
                          Our Services
                        </a>
                        <a className="link btn btn-primary activeBorder" href="contact">
                          Contact Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <div className="single-slider bg-with-black">
              <div className="img">
                <img src={slider3} alt="slider img 3" />
              </div>
              <div className="content text-right">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="slider-overlay-container">
  <div className="slider-overlay"></div>
  <div className="slider-content">
                      <h3 className="intro animated">
                        <span className="activeColor1">TRACS</span> 
                      </h3>
                      <h2 className="title animated">End-to-End Project Delivery</h2>
                      <p className="text animated">
                         From in-house design and engineering to expert installation and ongoing maintenance,
  <br />
  TRACS provides complete, accountable HVAC services for complex commercial builds.
                      </p>
                      </div>
                     </div>
                      <div className="buttons animated">
                        <a className="link btn btn-primary" href="services">
                          Our Services
                        </a>
                        <a className="link btn btn-primary activeBorder" href="contact">
                          Contact Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <div className="h1-featured">
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-lg-6 mb-4 mb-md-0">
              <div className="featured-img">
                <img className="img-fluid" src={featuredimg} alt="Featured" />
              </div>
            </div>
            <div className="col-md-7 col-lg-6">
              <div
                className="section-title h1-spacer wow fadeInUp animated"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div className="section-thumb">
                  <img src={titleicon} alt="title icon" />
                </div>
                <div className="section-body">
                  <h6 className="sub-title activeColor">Welcome to</h6>
                  <h3 className="m-0 main-title">TRACS Airconditioning</h3>
                </div>
              </div>

              <div className="row">
  <div className="col-md-6">
    <div
      className="featured-item wow fadeInUp animated"
      data-wow-delay="0ms"
      data-wow-duration="1500ms"
    >
      <div className="featured-icon">
        <i className="flaticon-solution"></i>
      </div>
      <h5 className="featured-item-title">
        Design &amp; <br /> Engineering
      </h5>
      <p className="featured-content">
        In-house mechanical design and 3D BIM drafting deliver custom HVAC
        solutions tailored for commercial, residential, and industrial projects.
      </p>
    </div>
  </div>
  <div className="col-md-6">
    <div
      className="featured-item wow fadeInUp animated"
      data-wow-delay="0ms"
      data-wow-duration="1500ms"
    >
      <div className="featured-icon">
        <i className="flaticon-cogwheel"></i>
      </div>
      <h5 className="featured-item-title">
        Ductwork &amp; <br /> Pipework
      </h5>
      <p className="featured-content">
        Expertise in sheet metal duct fabrication, complex routing, and chilled,
        condenser, and refrigerant pipe installations to Australian standards.
      </p>
    </div>
  </div>
  <div className="col-md-6">
    <div
      className="featured-item wow fadeInUp animated"
      data-wow-delay="0ms"
      data-wow-duration="1500ms"
    >
      <div className="featured-icon">
        <i className="flaticon-analytics"></i>
      </div>
      <h5 className="featured-item-title">
        Project <br /> Management
      </h5>
      <p className="featured-content">
        End-to-end delivery across multi-storey, complex, and remote builds with
        a strong track record in mining, education, and healthcare sectors.
      </p>
    </div>
  </div>
  <div className="col-md-6">
    <div
      className="featured-item wow fadeInUp animated"
      data-wow-delay="0ms"
      data-wow-duration="1500ms"
    >
      <div className="featured-icon">
        <i className="flaticon-machinery"></i>
      </div>
      <h5 className="featured-item-title">
        HVAC <br /> Maintenance
      </h5>
      <p className="featured-content">
        Dedicated service teams provide preventative maintenance and rapid
        emergency response to keep climate systems operating reliably.
      </p>
    </div>
  </div>
</div>

              {/* <div className="row">
                <div className="col-md-6">
                  <div
                    className="featured-item wow fadeInUp animated"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="featured-icon">
                      <i className="flaticon-piston"></i>
                    </div>
                    <h5 className="featured-item-title">
                      Automotive <br /> Manufacturing
                    </h5>
                    <p className="featured-content">
                      There are many variations of passages of Lorem Ipsum available but there is majority to alteration.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="featured-item wow fadeInUp animated"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="featured-icon">
                      <i className="flaticon-cogwheel"></i>
                    </div>
                    <h5 className="featured-item-title">
                      Mechanical <br /> Engineering
                    </h5>
                    <p className="featured-content">
                      There are many variations of passages of Lorem Ipsum available but there is majority to alteration.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="featured-item wow fadeInUp animated"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="featured-icon">
                      <i className="flaticon-concrete"></i>
                    </div>
                    <h5 className="featured-item-title">
                      Industrial <br /> Construction
                    </h5>
                    <p className="featured-content">
                      There are many variations of passages of Lorem Ipsum available but there is majority to alteration.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="featured-item wow fadeInUp animated"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="featured-icon">
                      <i className="flaticon-oil-platform"></i>
                    </div>
                    <h5 className="featured-item-title">
                      Oil &amp; Gas <br /> Energy
                    </h5>
                    <p className="featured-content">
                      There are many variations of passages of Lorem Ipsum available but there is majority to alteration.
                    </p>
                  </div>
                </div>
              </div> */}
              <div
                className="work-counter wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div className="row">
                  <div className="col-6 col-md-4 col-12">
                    <div
                      className="single-counter wow fadeIn"
                      data-wow-delay="100ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="content">
                        <h2
                          className="counter counter-up"
                          data-counterup-time="1500"
                          data-counterup-delay="30"
                        >
                          26+
                        </h2>
                        <h5 className="m-0">Years</h5>
                        <h5 className="m-0 activeColor">Experience</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-12">
                    <div
                      className="single-counter wow fadeIn"
                      data-wow-delay="100ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="content">
                        <h2
                          className="counter counter-up"
                          data-counterup-time="1500"
                          data-counterup-delay="30"
                        >
                          150+
                        </h2>
                        <h5 className="m-0">Project</h5>
                        <h5 className="m-0 activeColor">Completed</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-12">
                    <div
                      className="single-counter wow fadeIn"
                      data-wow-delay="100ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="content">
                        <h2
                          className="counter counter-up"
                          data-counterup-time="1500"
                          data-counterup-delay="30"
                        >
                         30+
                        </h2>
                        <h5 className="m-0">Workers</h5>
                        <h5 className="m-0 activeColor">Employed</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="h1-markets">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <div className="section-thumb">
                  <img src={titleicon} alt="title icon" />
                </div>
                <div className="section-body">
                  <h6 className="sub-title activeColor">We Can Do</h6>
                  <h3 className="m-0 main-title">Our Services</h3>
                </div>
              </div>
            </div>

           {[1, 2, 3, 4, 5, 6].map((index) => (
  <div key={index} className="col-12 col-md-6 col-lg-4">
    <div
      className={`market-items wow fadeIn animated`}
      data-wow-delay={`${index * 100}ms`}
      data-wow-duration="1500ms"
    >
      <div className="card border-0 rounded-0">
        <div className="card-img position-relative">
          <a >
            <div className="img-overlay style-1 activeColor d-flex align-items-center justify-content-center">
              <i className="fa fa-link" aria-hidden="true"></i>
            </div>
            <img
              className="card-img-top rounded-0 img-fluid"
              src={services[index]} alt={`market img ${index}`} 
            />
          </a>
          <a >
            <div className="shape"></div>
            <div className="categories">
              <i
                className={`flaticon-${
                  index === 1
                    ? 'solution'
                    : index === 2
                    ? 'cogwheel'
                    : index === 3
                    ? 'gear'
                    : index === 4
                    ? 'analytics'
                    : index === 5
                    ? 'factory'
                    : 'machinery'
                }`}
              ></i>
            </div>
          </a>
        </div>
        <div className="card-body pl-0 pr-0">
          <a href="#">
            <h5 className="card-title mb-1">
              {index === 1
                ? 'Design & Engineering'
                : index === 2
                ? 'Ductwork Installation'
                : index === 3
                ? 'Pipework Installation'
                : index === 4
                ? 'Project Management'
                : index === 5
                ? 'Construction'
                : 'HVAC Maintenance & Servicing'}
            </h5>
          </a>
          <p className="card-text">
            {index === 1
              ? 'Custom HVAC designs with full in-house mechanical engineering, 3D drafting, and BIM coordination for seamless project integration.'
              : index === 2
              ? 'High-quality sheet metal duct fabrication and installation with expertise in complex routing and superior acoustic performance.'
              : index === 3
              ? 'Specialist installation of chilled water, condenser water, and refrigerant pipe systems, compliant with Australian standards.'
              : index === 4
              ? 'Comprehensive end-to-end project management, proven in multi-storey builds, complex designs, and remote industrial sites.'
              : index === 5
              ? 'Turnkey HVAC delivery from concept through to commissioning, serving mining, healthcare, education, and infrastructure sectors.'
              : 'Dedicated service teams offering preventative maintenance, tailored programs, and rapid response for system reliability.'}
          </p>
        </div>
      </div>
    </div>
  </div>
))}


          </div>
        </div>
      </div>




      <div className="h1-latest-project">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <div className="section-thumb">
                  <img src={titleicon} alt="title icon" />
                </div>
                <div className="section-body">
                  <h6 className="sub-title activeColor">Latest</h6>
                  <h3 className="m-0 main-title">Projects</h3>
                </div>
              </div>


               <div className="mixitup-menus mb-4">
        {filters.map((label, index) => (
          <button
            key={index}
            className={`btn filiter-menu-btn me-2 ${
              selectedFilter === label ? 'active' : ''
            }`}
            onClick={() => setSelectedFilter(label)}
          >
            {label}
          </button>
        ))}
      </div>

            <div id="mixitup-projects" className="row">
  {filteredProjects.map((project, index) => (
    <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card border-0 rounded-0 h-100 shadow-sm" style={{background: 'beige'}}>
        <div className="card-body">
         <h5 className="card-title"> {(project.title == "Educational" || project.title == "Other" || project.title == "Design & Construct")  ? `${project.title} Projects` : project.title} </h5>
           
          <ul className="list-unstyled mt-3" style={{textAlign:'left'}}>
            
            {project.items.map((item, i) => (
              
              <li key={i} className="mb-1">
                <i className="fa fa-check-circle me-2 text-primary" style={{marginRight:'3%'}}></i>
                 {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  ))}
</div>


 {/* <div id="mixitup-projects" className="row">
        {filteredProjects.map((project, index) => (
          <div
            key={index}
            className="col-12 col-md-6 col-lg-4 mb-4"
          >
            <div className="card border-0 rounded-0">
              <div className="card-img position-relative">
                <a href="#">
                  <div className="img-overlay style-1 activeColor d-flex align-items-center justify-content-center text-center">
                    <div className="col-md-10">
                      <h5 className="text-light">{project.title}</h5>
                      <p className="text-light">{project.text}</p>
                    </div>
                  </div>
                  <img
                    className="card-img-top rounded-0 img-fluid"
                    src={project.img}
                    alt={project.title}
                  />
                </a>
               
              </div>
            </div>
          </div>
        ))}
      </div> */}
   

              {/* <div id="mixitup-projects" className="row">
                {[
                  { img: project1, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'Educational Restaurant' },
                  { img: titleicon, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'Church Apartments ' },
                  { img: project1, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'Aged Care chemical mechanical' },
                  { img: slider2, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'mechanical materials powerEnergy agriculture' },
                  { img: project1, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'powerEnergy mechanical chemical agriculture' },
                  { img: project1, title: 'Industry', text: 'There are many variations of passages a of Lorem Ipsum available but the at majority suffered.', categories: 'powerEnergy agriculture chemical' },
                ].map((project, index) => (
                  <div key={index} className={`mix ${project.categories} col-12 col-md-6 col-lg-4`}>
                    <div className="card border-0 rounded-0">
                      <div className="card-img position-relative">
                        <a href="#">
                          <div className="img-overlay style-1 activeColor d-flex align-items-center justify-content-center text-center">
                            <div className="col-md-10">
                              <h5 className="text-light">{project.title}</h5>
                              <p className="text-light">{project.text}</p>
                            </div>
                          </div>
                          <img className="card-img-top rounded-0 img-fluid" src={project.img} alt={project.title} />
                        </a>
                        <a href="#">
                          <div className="shape"></div>
                          <div className="categories">
                            <img className="img-fluid" src="img/big-arrow.png" alt="cat img" />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>

     
     

     <Footer/>



    </div>

  );
}